export default {
    password: {
        title: "Change Password",
        currentPassword: "Current Password",
        confirmPassword: "Confirm Password",
        password: "New Password",
        button: "Update",
        successMessage: "Password has been updated successfully.",
    },
    email: {
        title: "Change Email",
        emailLabel: "Email",
        button: "Update",
        successMessage: "Email has been updated successfully.",
    },
    paymentMethod: {
        title: 'Payment method',
        button: {
            edit: "Edit",
            removeCard: "Remove card",
            addCard: "add card",
        },
        validThru: 'Valid through',
        billingAddress: 'Billing address',
        modal: {
            addCard: 'Add credit card',
            editCard: 'Edit credit card',
            cardInformation: 'Card information',
            billingAddress: 'Billing address',
            input: {
                firstName: {
                    label: 'First name',
                    placeholder: 'Enter first name'
                },
                lastName: {
                    label: 'Last name',
                    placeholder: 'Enter last name'
                },
                cardNumber: {
                    label: 'Card number',
                    placeholder: '0000 0000 0000 0000',
                },
                validThru: {
                    label: 'Valid through',
                    placeholder: 'MM/YY',
                },
                cvv: {
                    label: 'CVV',
                    placeholder: '000',
                },
                country: 'Country',
                city: {
                    label: 'City',
                    placeholder: 'Select a city',
                },
                address: {
                    label: 'Address',
                    placeholder: 'Enter the address'
                },
                zipCode: {
                    label: 'Zip code',
                    placeholder: '00000'
                },
                phoneNumber: {
                    label: 'Phone number',
                    placeholder: '067/067-067'
                }
            },
            button: {
                cancel: 'Cancel',
                save: 'Save',
                add: 'Add'
            }
        }
    },
    deleteAccount: {
        title: "Delete Account",
        warningMessage: "Once you delete your account, there is no going back. Please be certain.",
        emailLabel: "Email",
        button: "Delete Account",
        modal: {
            title: "Are you sure you want to do this?",
            deleteDataWarning: "We will immediately delete all of your data including your addresses, orders, comments, reviews, cart and wish list items.",
            storeAccessWarning: "Also you will not be able to access any store that's linked with your account.",
            emailLabel: "Your email",
            confirmPassword: "Confirm your password",
        }
    },
    user: {
        title: "User Info",
        avatar: "Avatar",
        firstName: "First Name",
        lastName: "Last Name",
        fullName: "Full name",
        button: "Update",
        successMessage: "User info has been updated successfully.",
        settings: {
            title: 'Settings',
            session: {
                title: "Sessions",
                loginHistory: "Login history overview",
                activeNow: "Active now",
                logOut: "Log out",
            },
            account: {
                title: "Account settings",
                buttons: {
                    edit: "Edit",
                    cancel: "Cancel",
                    save: "Save"
                },
                firstName: "First name",
                lastName: "Last Name",
                email: "Email",
                password: "Password",
                city: "City",
                street: "Street",
                number: "Street number"
            },
            twoFactorAuth: {
                title: 'Two-factor authentication',
                helpProtectAccount: {
                    title: 'Help protect your account',
                    message: "If we notice an attempted login from a device or browser we don't recognize, we'll ask you for password and a verification code."
                },
                twoFactorIsOn: {
                    title: 'Two-face authentication is on',
                    message: "We'll ask for a verification code via your security method if we notice a login from an unrecognized device or browser."
                },
                method: {
                    label: {
                        security: {
                            selectMethod: 'Select a security method',
                            yourMethod: 'Your security method'
                        },
                        backup: 'Add a backup method'
                    },
                    authApp: {
                        title: 'Authentication app',
                        reccomended: 'Recommended',
                        message: 'Use Google Authenticator to generate verification codes for more protection.',
                        button: 'Use Authentication App',
                        selectedMethod: {
                            message: "You'll receive a login code via an authentication app",
                            button: 'Turn off'
                        }
                    },
                    textMsg: {
                        title: 'Text message (SMS)',
                        message: "Use text messages (SMS) to receive verification codes. For your protection, phone numbers used for two-factor authentication can't be used to reset your password when two-factor authentication is on.",
                        button: 'Use Text message (SMS)'
                    },
                    recoveryCodes: {
                        title: 'Recovery codes',
                        message: "Use recovery codes to log in if you lose your phone or can't receive verification code via text message or and authentication app.",
                        button: 'Setup'
                    }
                },
                modal: {
                    title: 'Two-factor authentication',
                    thirdParty: {
                        title: 'Set up via third-party authenticator',
                        message: 'Please use Google Authenticator to scan this QR code.',
                        enterCode: 'Or enter this code into your authentication app',
                        button: {
                            close: 'Close',
                            secureAccount: 'Secure Account'
                        }
                    },
                    selectNumber: {
                        title: 'Select your phone number',
                        message: 'Choose a mobile phone number that is already on your account or add a new number for two-factor authentication. This is the number you will receive your verification code on.',
                        addPhoneNumber: 'Add phone number',
                        button: {
                            close: 'Close',
                            continue: 'Continue'
                        }
                    },
                    addNumber: {
                        title: 'Add phone number',
                        message: 'This number will be enabled for two-factor authentication and login.',
                        input: {
                            countryCode: 'Country code',
                            phoneNumber: {
                                label: 'Phone number',
                                placeholder: 'Enter your phone number'
                            }
                        },
                        button: {
                            close: 'Close',
                            continue: 'Continue'
                        }
                    },
                    enterCode: {
                        title: 'Enter code',
                        message: 'Enter the 6-digit code you got to finish setting up two-factor authentication.',
                        button: {
                            close: 'Close',
                            continue: 'Continue',
                            resendCode: 'Resend code'
                        }
                    },
                    authIsOn: {
                        title: 'Two-Factor Authentication is On',
                        message: "We'll send a verification code to this number if we notice an attempted login from a device or browser that we didn't recognize.",
                        button: {
                            confirm: 'Confirm'
                        }
                    },
                    recoveryCodes: {
                        title: 'Recovery codes',
                        message: "Use recovery codes to log in if you lose your phone or can't receive a verification code via text message or an authentication app.",
                        button: {
                            close: 'Close',
                            getCodes: 'Get codes'
                        },
                        listedCodes: {
                            of: 'of',
                            remaining: 'remaining',
                            code: 'CODE',
                            button: {
                                getNewCodes: 'Get new codes',
                                download: 'Download',
                                close: 'Close'
                            }
                        }
                    }
                }
            },
        }
    },
    interests: {
        title: 'Store Categories'
    },
    addresses: {
        deliveryAddressesCard: {
            title: 'Adrese dostave',
            button: {
                edit: 'Izmijeni',
                primaryAddress: 'Glavna adresa',
                setAsPrimaryAddress: 'Podesi kao glavnu adresu',
                addNewAddress: 'Dodaj novu adresu'
            }
        },
        modal: {
            addNewAddressTitle: 'Dodaj novu adresu',
            editAddressTitle: 'Izmijeni adresu',
            input: {
                firstName: {
                    label: 'First name',
                    placeholder: 'Enter first name'
                },
                lastName: {
                    label: 'Last name',
                    placeholder: 'Enter last name'
                },
                country: {
                    label: 'Country'
                },
                city: {
                    label: 'City',
                    placeholder: 'Select a city'
                },
                address: {
                    label: 'Address',
                    placeholder: 'Enter the address'
                },
                addressNumber: {
                    label: 'Number',
                    placeholder: 'xx'
                },
                phoneNumber: {
                    label: 'Phone number',
                    placeholder: '(+382)'
                }
            },
            button: {
                cancel: "Cancel",
                add: "Add",
                save: "Save",
                delete: "Delete"
            }
        },
        toastr: {
            addressAdded: 'Address is successfully added',
            addressEdited: 'Address is successfully edited',
            addressDeleted: 'Address is successfully deleted',
        }
    }
};

